export const predefinedMessageIds = {
  datetime: "lbl.日時",
  date: "lbl.日付",
  json: "lbl.JSON",
};
